// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__11FXZ","label":"Category_label__2OL_1","content":"Category_content__2eJSk","header":"Category_header__kz4gV","location":"Category_location__2jvFZ"};